// import { TweenMax } from 'gsap'
// import 'gsap/ScrollToPlugin'
import { MarkerWithLabel } from '@google/markerwithlabel'

export default {
  init () {
    var minimumStores = 5
    var maximumRadius = 20
    var radiusKmGap = 1
    var map
    var radiusCircle
    var results = []
    var markersOnMap = []
    var storesOnMap = []
    var userMarker
    var geocoder
    var infoWindow
    var preAjax = window.a9sf823fa

    var getCountry
    var getRegion
    var getUrlParam
    var submitSearch
    var pinSymbol
    var hasSearchParam = null
    var geocodeAddress
    var geocodeLocation
    var filterStores
    var displayStores
    var displayError
    var resetMap
    var getStoreHTML
    var openInfoWindow
    var addStore
    var geolocate
    var toggleTab
    var isLoading
    var activeMarker = null

    var $html = $('html')
    var $btnSearchStores = $('.btn--search', '.locator-form__form')
    var $locator = $('.locator')
    var $storesList = $('.stores-list')
    var $storesCol = $('.locator__list')
    var $searchField = $('.locator-form__field')
    var $companyField = $('.js-companies')
    var $btnGeolocation = $('.btn--geolocation')
    var $mobileTab = $('.locator__tabs a')

    // Focus on Search Field
    $searchField.get(0).focus()

    var curPos = []

    // Get User Region
    getRegion = function () {
      $.ajax({
        url: preAjax['sdc-xu23rf'],
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'geocode', // Your custom hook/action name
          security: preAjax['maWo3eSqyd'], // A nonce value
        },
      })
      .done(function(data){

        console.log('data: ', data)

        var filterOptions = {}

        curPos.city = data.city
        curPos.regionCode = data.region_name
        curPos.country = data.country_name
        curPos.latitude = data.latitude
        curPos.longitude = data.longitude

        var geocoder = new google.maps.Geocoder();
        geocoder.geocode( {'address' : data.city + ', ' + data.region_name + ', ' + data.country_name}, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            filterOptions.address_lat_lng = results[0].geometry.location;
            console.log(data.city + ', ' + data.region_name + ', ' + data.country_name)
            console.log(filterOptions.address_lat_lng)
            filterStores(filterOptions)
          }
        });
      })
    }

    // Get Site Country
    // TODO: Fix Rules for Canada/US
    getCountry = function () {
      var country = window.locatorCountry;
      console.log(country);

      return country
    }

    // Initialize map on document ready
    window.initMap = function () {

      var myOptions
      var latlng = new google.maps.LatLng(46.308367, -99.356993); //you can use any location as center on map startup
      // var latlng = new google.maps.LatLng(options.latitude, options.latitude); //you can use any location as center on map startup
      var country = getCountry()

      geocoder = new google.maps.Geocoder()

      geocoder.geocode( {'address' : country}, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          map.setCenter(results[0].geometry.location);
        }
      });

      myOptions = {
        zoom: 4,
        center: latlng,
        mapTypeControl: true,
        mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
        navigationControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scaleControl: true,
        styles: [{"stylers": [{ "saturation": -100 }]}]

      };

      map = new google.maps.Map(document.getElementById("map"), myOptions);

      getUrlParam()

      if(hasSearchParam) {
        console.log('use search')
        submitSearch()
      } else {
        console.log('use IP')
        getRegion()
      }


      google.maps.event.addListener(map, 'click', function(){
        if (infoWindow) {
          infoWindow.setMap(null);
          infoWindow = null;
        }
      })

    }

    getUrlParam = function () {
      if(window.location.href.indexOf('location') > -1 ) {
        hasSearchParam = true
      }
    }

    // $(window).on('load', function(){
    //   // getUrlParam();
    // });


    submitSearch = function (e) {
      // e.preventDefault()
      // alert($searchField.val())
      var filterOptions = {}
      var $this = $(this)

      // Prevent submit if fields are empty
      if ($searchField.val() === '') {
        $searchField.get(0).focus()
        return false
      } else {
        isLoading()
        resetMap()
        geocodeAddress($searchField.val())
      }
      return false;
    }

    isLoading = function (notLoading) {
      if (notLoading === false) {
        $locator.removeClass('is-loading')
        $btnSearchStores.removeAttr('disabled')
      } else {
        $locator.addClass('is-loading')
        $btnSearchStores.attr('disabled', 'disabled')
      }
    }

    resetMap = function () {
      // Remove radius circle
      if (radiusCircle) {
        radiusCircle.setMap(null);
        radiusCircle = null;
      }

      // Remove User Marker
      userMarker.setMap(null);

      // Remove all markers
      for (var i = 0; i < markersOnMap.length; i++) {
        if (markersOnMap[i]) {
          markersOnMap[i].setMap(null);
          markersOnMap[i] = null;
        }
      }
      results = []
      markersOnMap = []
      storesOnMap = []
    }

    getStoreHTML = function (location) {
      var infoWindowHTML = ''
      var storeName = location['post_title']
      var storeAddress = (location['acf_fields'].hasOwnProperty('address')) ? location['acf_fields']['address'] : ''
      var storePhone = (location['acf_fields'].hasOwnProperty('phone')) ? location['acf_fields']['phone'] : ''
      var storeWebsite = (location['acf_fields'].hasOwnProperty('website')) ? location['acf_fields']['website'] : ''

      if (location['acf_fields'].hasOwnProperty('city')) {
        storeAddress += ', ' + location['acf_fields']['city']
      }
      if (location['acf_fields'].hasOwnProperty('province')) {
        storeAddress += ', ' + location['acf_fields']['province']
      }
      if (location['acf_fields'].hasOwnProperty('postal_code')) {
        storeAddress += ', ' + location['acf_fields']['postal_code']
      }

      infoWindowHTML += '<p class="stores-list__title h4">' + storeName + '</p>'
      if (storeAddress !== '') {
        infoWindowHTML += '<p class="stores-list__address">' + storeAddress + '</p>'
      }
      infoWindowHTML += '<div class="stores-list__links">'
      if (storePhone !== '') {
        infoWindowHTML += '<a href="tel:' + storePhone + '"><i class="icon-phone"></i><span>' + storePhone + '</span></a>'
      }
      infoWindowHTML += '<a href="https://www.google.com/maps/dir/?api=1&destination=' + encodeURI(storeAddress) + '" target="_blank"><i class="icon-location"></i><span>' + window.translations['directions'] + '</span></a>'

      if (storeWebsite !== '') {
        storeWebsite = storeWebsite.indexOf('http://') < 0 && storeWebsite.indexOf('https://') < 0 ? 'http://' + storeWebsite : storeWebsite
        infoWindowHTML += '<a href="' + storeWebsite + '" target="_blank"><i class="icon-earth"></i><span>' + window.translations['view_website'] + '</span></a>'
      }

      infoWindowHTML += '</div>'

      return infoWindowHTML
    }

    geocodeAddress = function (stores, filters) {
      // var i;
      var address = $searchField.val();
      var filterOptions = {}
      var bounds

      if (geocoder) {
        geocoder.geocode({'address': address}, function (results, status) {

          if (status == google.maps.GeocoderStatus.OK) {
            if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
              filterOptions.address_lat_lng = results[0].geometry.location;
              console.log(filterOptions.address_lat_lng)
              displayError('')
              filterStores(filterOptions)
            } else {
              // displayError('No results found while geocoding!');
              displayError(window.translations['no_location']);
            }
          } else {
            displayError(window.translations['no_location']);
            // displayError('Geocode was not successful: ' + status);
          }
        });
      }
    }

    geocodeLocation = function (location) {
      if (geocoder) {
        geocoder.geocode({'location': location}, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            displayError('')
            $searchField.val(results[0].formatted_address)
          } else {
            displayError(window.translations['no_location']);
          }
        });
      }
    }

    filterStores = function (options) {

        markersOnMap = []
        storesOnMap = []

        var thisIndex = 0;

        for (var j = 0; j < stores.length; j++) {
          (function (store) {

            var storeLat = store['acf_fields']['latitude']
            var storeLng = store['acf_fields']['longitude']
            var markerLatLng = new google.maps.LatLng(storeLat, storeLng);
            // If no address provided, make distance to 999999 meters so it won't be a false positive
            var distanceFromLocation = google.maps.geometry.spherical.computeDistanceBetween(options.address_lat_lng, markerLatLng);

            // Distance in meters between your location and the marker
            if (distanceFromLocation <= maximumRadius * 1000) {
              thisIndex++
              console.log({store, distanceFromLocation});
              results.push([store, distanceFromLocation]);

            }
          })(stores[j]);

        }

        results.sort(sortByDistane);

        function sortByDistane(a,b) {
          if (a[1] === b[1]) {
              return 0;
          }
          else {
              return (a[1] < b[1]) ? -1 : 1;
          }
        }

        for (var k = 0; k < results.length; k++) {
          addStore(results[k][0],k + 1)
        }


        // radiusKm += radiusKmGap
        // console.log(radiusKm);
      // }

      radiusCircle = new google.maps.Circle({
        strokeColor: '#808080',
        strokeOpacity: .3,
        fillColor: '#808080',
        fillOpacity: .1,
        center: options.address_lat_lng,
        radius: maximumRadius * 1000,
        clickable: false,
        map: map,
      });

      userMarker = new google.maps.Marker({
        position: options.address_lat_lng,
        map: map,
        icon: {
          fillColor: '#99BCD9',
          fillOpacity: .9,
          path: google.maps.SymbolPath.CIRCLE,
          scale: 5,
          strokeColor: '#2B7BBE',
          strokeOpacity: 1,
          strokeWeight: 3,
        },
      });

      if (radiusCircle) {
        console.log('Fit Bounds')
        map.fitBounds(radiusCircle.getBounds());
        map.setZoom(13);
      }

      displayStores(storesOnMap)

    }

    pinSymbol = function (color, scale) {
      return {
        path: 'm10.7 0c4.2515 0 7.7 3.4474 7.7 7.7 0 5.775-7.7 14.3-7.7 14.3s-7.7-8.525-7.7-14.3c0-4.2526 3.4485-7.7 7.7-7.7z',
        anchor: new google.maps.Point(11,22),
        fillColor: color,
        fillOpacity: 1,
        strokeColor: '#fff',
        strokeWeight: 2,
        scale: scale,
        labelOrigin: new google.maps.Point(10.5, 9),
        labelClass: 'locator__label'
      };
    }

    addStore = function (store,storeIndex) {
      // var infoWindowHTML
      var index =  String(storeIndex)
      var storeName = store['post_title']
      var storeLat = store['acf_fields']['latitude']
      var storeLng = store['acf_fields']['longitude']
      var markerLatLng = new google.maps.LatLng(storeLat, storeLng)

      var newMarker = new google.maps.Marker({
        position: markerLatLng,
        map: map,
        title: storeName,
        label: {
          text: index,
          color: '#ffffff',
          fontFamily: 'freight-sans-pro, sans-serif',
          fontSize: '16px',
          fontWeight: '700',
        },
        icon: pinSymbol('#010101', 2),
        // zIndex: 10
      });
      // var newDefaultMarker = new google.maps.Marker({
      //   position: markerLatLng,
      //   map: map,
      // });



      // infoWindowHTML = getStoreHTML(store)
      // infoWindowHTML = '<div class="padding-v-tiny store-info-window">' + infoWindowHTML + '</div>'

      google.maps.event.addListener(newMarker, 'click', function () {

        if(activeMarker != null) {
          activeMarker.setIcon(pinSymbol('#010101', 2));
          activeMarker.setZIndex();
          $('.js-open-info').removeClass('is-active');
        }

        console.log(newMarker);

        newMarker.setIcon(pinSymbol('#ff7b94', 3));
        newMarker.setZIndex(999);
        activeMarker = newMarker;
        var latLng = newMarker.getPosition(); // returns LatLng object
        map.setCenter(latLng); // setCenter takes a LatLng object
        map.setZoom(15);

        var thisInfo = $('.js-open-info').eq(storeIndex - 1);
        var thisInfoPos = $(thisInfo).position().top;
        var thisInfoHTML = $(thisInfo).html();
        $('.locator__mobile-infobox').empty().append(thisInfoHTML);
        $(thisInfo).addClass('is-active');
        $('.locator__list').scrollTop(thisInfoPos);
      });

      markersOnMap.push(newMarker);
      storesOnMap.push(store)
    }

    displayError = function (message) {
      $('.search-error').text(message)
      isLoading(false)
    }

    displayStores = function (stores) {
      var storesHTML = ''

      // console.log($storesCol.width())
      // if (!$storesCol.hasClass('is-shown')) {
      //   TweenMax.to($storesCol, .2, {
      //     width: '40%',
      //     ease: Power3.easeOut,
      //     onComplete: function () {
      //       $storesList.addClass('is-shown')
      //     },
      //   })
      // }

      if (stores.length) {
        for (var i = 0, len = stores.length; i < len; i++) {
          var store = stores[i]
          var storeHTML = getStoreHTML(store)

          storeHTML = '<li data-id="'+ store['ID'] + '" class="js-open-info">' + storeHTML + '</li>';
          storesHTML += storeHTML
        }

        $storesList.html(storesHTML)
      } else {
        $storesList.html('<li><p>' + window.translations['no_store'] + ' ' + maximumRadius + ' ' + distanceUnit +'.</p></li>')
      }

      isLoading(false)
    }

    openInfoWindow = function (event) {
      // event.preventDefault()

      var index = $(this).index()
      var marker = markersOnMap[index]
      var thisHTML = $(this).html();

      $('.js-open-info').removeClass('is-active');
      $(this).addClass('is-active');
      $('.locator__mobile-infobox').empty().append(thisHTML);

      if(activeMarker != null) {
        activeMarker.setIcon(pinSymbol('#010101', 2));
        activeMarker.setZIndex();
      }

      markersOnMap[index].setIcon(pinSymbol('#ff7b94', 3));
      markersOnMap[index].setZIndex(999);
      activeMarker = markersOnMap[index];
      var latLng = markersOnMap[index].getPosition(); // returns LatLng object
      map.setCenter(latLng);
      map.setZoom(15);
       //google.maps.event.trigger(marker, 'click');
    }

    geolocate = function (e) {
      e.preventDefault()

      var filterOptions = {}

      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        isLoading()
        navigator.geolocation.getCurrentPosition(function(position) {
          // var pos = {
          //   lat: position.coords.latitude,
          //   lng: position.coords.longitude,
          // };
          // console.log(position)
          var geoLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          filterOptions.address_lat_lng = geoLatLng
          geocodeLocation(geoLatLng)
          // console.log(geoLatLng)
          // console.log(pos)
          resetMap()
          displayError('')
          filterStores(filterOptions)

          // infoWindow.setPosition(pos);
          // infoWindow.setContent('Location found.');
          // infoWindow.open(map);
          // map.setCenter(pos);
        }, function() {
          displayError(window.translations['geolocation_fail'])
        },
        {
          timeout: 27000,
          maximumAge: 30000,
        });
      } else {
        // Browser doesn't support Geolocation
        displayError(window.translations['geolocation_fail'])
      }
    }

    // Hide the geolocation button if not supported
    if (!("geolocation" in navigator) || (window.location.hostname !== 'localhost' && window.location.origin.indexOf('https://') < 0)) {
      $html.addClass('no-geolocation')
      $btnGeolocation.attr('disabled', true)
    }

    toggleTab = function (e) {
      e.preventDefault();
      var thisTab = $(this).attr('href');
      $('.locator__tabs a').removeClass('is-active');
      $(this).addClass('is-active');
      $('.locator__tab').removeClass('is-active');
      $(thisTab).addClass('is-active');
      return false;
    }

    $mobileTab.click( toggleTab );

    $btnGeolocation.click( geolocate )
    $btnSearchStores.click(submitSearch)
    $storesList.on('click', '.js-open-info', openInfoWindow)
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/locator.js